<template>
  <b-form-group :id="'group' + formGroupId" class="text-input-group" :label="placeholder" :label-for="formGroupId">
    <b-form-textarea
      :id="formGroupId"
      v-model="text"
      :placeholder="placeholder"
      :type="'text'"
      :rows="rows"
      size="sm"
      :required="required"
      @input="updateValue"
    />
  </b-form-group>
</template>

<script>
import { BFormTextarea } from 'bootstrap-vue';

export default {
  name: 'Text',
  components: { 'b-form-textarea': BFormTextarea },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 3
    },
    formGroupId: {
      type: String,
      default: 'text-input-group'
    }
  },
  data: function() {
    return {
      text: null
    };
  },
  mounted() {
    this.text = this.value;
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style scoped>
.text-show-toggle {
  position: absolute;
  top: 5px;
  right: 8px;
  cursor: pointer;
}

.text-input-group {
  position: relative;
}
</style>
